import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { withoutAuthAxios } from "../config/config";
import { toast } from "react-toastify";
import IsLoadingHOC from "./IsLoadingHOC";
import { useDispatch, useSelector } from "react-redux";
import { BsEyeSlash, BsEye } from "react-icons/bs";
import {
  setAccessToken,
  setIsAuthenticated,
  saveUser,
} from "../Redux/Reducers/authSlice";

const Login = (props) => {


  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { accessToken } = useSelector((state) => state.auth);
  const [showPassword, setShowPassword] = useState(false);
  console.log("DEBUGGGG12")
  useEffect(() => {
    if (accessToken) {
      navigate("/");
    }
  }, []);
  const { setLoading } = props;

  const [data, setdata] = useState({
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setdata((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
   // const payload = data;

    const payload={
     email:data.email.toLowerCase(),
     password:data.password
  
    }

    setLoading(true);
    await withoutAuthAxios()
      .post("/auth/login", payload)

      .then((response) => {
        setLoading(false);
        const resData = response.data;
        if (resData.status == 1) {
          toast.success(resData?.message);
          dispatch(saveUser(resData?.data?.user));
          dispatch(setAccessToken(resData?.data?.token));
          navigate("/");
        } else {
          toast.error(resData.message);
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.response.data.message);
      });
  };

  return (
    <div className="flex shadow-lg flex-1 flex-col justify-center px-5 py-6 rounded-[20px] lg:px-5 bg-white border max-w-[400px] mx-auto absolute w-[95%] top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]">
      <div className="sm:mx-auto sm:w-full">
        <img
          className="mx-auto h-20 w-auto"
          src="./assets/images/final-logo.png"
          alt="Your Company"
        />
        <h2 className="mt-2 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
          Sign in to your account
        </h2>
      </div>

      <div className="mt-5 sm:mx-auto sm:w-full ">
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label
              htmlFor="email"
              className="block text-sm font-medium leading-6 text-gray-900"
            >
              Email address
            </label>
            <div className="mt-2">
              <input
                id="email"
                name="email"
                type="email"
                onChange={handleChange}
                required
                className="block w-full rounded-md border-0 py-2 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>

          <div>
            <label
              htmlFor="email"
              className="block text-sm font-medium leading-6 text-gray-900"
            >
              Password
            </label>
            <div className="mt-2 relative">
              <input
                id="password"
                name="password"
                type={showPassword ? 'text':'password'}
                onChange={handleChange}
                autoComplete="current-password"
                required
                className="block w-full rounded-md border-0 py-2 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
              <div className="absolute top-[12px] right-[15px] cursor-pointer" onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? 
                <BsEyeSlash /> : 
                <BsEye /> }
              </div>
              
            </div>
          </div>

          <div>
            <p
              className="block text-sm font-medium leading-6 text-black underline cursor-pointer"
              onClick={()=>navigate("/forgot-password")}
            >
              Forgot Password?
            </p>
            
          </div>

          <div>
            <button
              type="submit"
              className="flex w-full justify-center rounded-md bg-black px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm"
            >
              Sign in
            </button>
          </div>
          <p className="text-center cursor-pointer" onClick={()=>navigate("/signup")}>Dont have an account?<span className="font-bold m-2">Register Now </span></p>
        </form>
      </div>
    </div>
  );
};

export default IsLoadingHOC(Login);
